import Gallery from "./Gallery";

const MermaidMagic = () => (
  <Gallery imageNames={["mermaid magic-01.png", "mermaid magic-02.png"]} />
);
export default MermaidMagic;
